import {
	GitBranch,
	GitPullRequest,
	GitPullRequestDraft,
	GitMerge,
	GitPullRequestClosed,
} from "lucide-react";
import { cn } from "@/lib/utils";
import type { PrState } from "@/services/task.service";

const PR_META: Record<
	PrState,
	{ label: string; className: string; Icon: typeof GitBranch }
> = {
	none: {
		label: "Branch",
		className: "bg-muted-subtle text-muted-foreground",
		Icon: GitBranch,
	},
	open: {
		label: "Open",
		className: "bg-primary/10 text-primary",
		Icon: GitPullRequest,
	},
	draft: {
		label: "Draft",
		className: "bg-muted-subtle text-muted-foreground",
		Icon: GitPullRequestDraft,
	},
	merged: {
		label: "Merged",
		className: "bg-secondary/10 text-secondary",
		Icon: GitMerge,
	},
	closed: {
		label: "Closed",
		className: "bg-danger/10 text-danger",
		Icon: GitPullRequestClosed,
	},
};

export function PrBadge({
	state,
	prNumber,
	className,
}: {
	state: PrState;
	prNumber?: number | null;
	className?: string;
}) {
	const meta = PR_META[state] ?? PR_META.none;
	const { Icon } = meta;
	const label =
		state !== "none" && prNumber ? `#${prNumber} ${meta.label}` : meta.label;
	return (
		<span
			className={cn(
				"inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium leading-none",
				meta.className,
				className,
			)}
		>
			<Icon className="h-3 w-3" />
			{label}
		</span>
	);
}
